/* eslint-disable react-hooks/exhaustive-deps */

import { Box, Button, CircularProgress, Container, Typography } from '@mui/material';
import { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getMerchantId } from 'redux/reducers/auth/selectors';
import {
	fetchContractDocumentRequest,
	getContractDocumentsRequest,
	getEmAssignmentRequest,
} from 'redux/reducers/settings/reducer';
import {
	getContractDocuments,
	getContractDocumentsLoader,
	getDownloadedDocuments,
	getDownloadedDocumentsLoader,
	getContractDocumentLoader,
	getEmAssignment,
} from 'redux/reducers/settings/selectors';
import { getOrganization, getUserInfo } from 'redux/reducers/user/selectors';
import { EasTableWithoutFilter } from 'ui/EasTableWithoutFilter';
import { THandleAction } from 'services/constants/tableStructureTypes';
import { IPageResponse } from 'services/constants/types';
import { tableStructure, TContractDocumentTableRow } from './tableStructure';
import CancelIcon from '@mui/icons-material/Cancel';

const ROWS = Array.from(new Array(6));

export const Contract: FC = () => {
	const dispatch = useDispatch();
	const organization = useSelector(getOrganization);
	const contractDocuments = useSelector(getContractDocuments);
	const contractDocumentsIsLoading = useSelector(getContractDocumentsLoader);
	const downloadedDocuments = useSelector(getDownloadedDocuments);
	const downloadedDocumentsIsLoading = useSelector(getDownloadedDocumentsLoader);
	const contractDocumentIsLoading = useSelector(getContractDocumentLoader);
	const xMerchantId = useSelector(getMerchantId);
	const userInfo = useSelector(getUserInfo);
	const emAssignment = useSelector(getEmAssignment);

	useEffect(() => {
		dispatch(
			getContractDocumentsRequest({
				emId: Number(organization?.id),
				body: { pageSize: 100, pageNumber: 1, filters: [], orderBy: [], searchString: '' },
			}),
		);
	}, [dispatch]);

	const handleDownloadDocument = (id: number, documentType: string, oid: number, name: string) => {
		dispatch(
			fetchContractDocumentRequest({
				emId: Number(organization?.id),
				attachmentId: id,
				fileName: name,
			}),
		);
	};
	const handleAction: THandleAction = (id, typeOfDialog) => {
		if (!contractDocuments) return;

		const doc = contractDocuments.data.find((item) => item.id === id);
		if (!doc) return;

		switch (typeOfDialog) {
			case 'Download':
				handleDownloadDocument(doc.id, doc.type, doc.typeId, doc.fileName);
				break;
			default:
				break;
		}
	};

	const handleCancellationRequest = () => {
		if (!emAssignment?.id) return;
		if (!userInfo) return;
		window.open(
			`https://form.jotform.com/253202901852046?q3_textbox1=${emAssignment.id}&company=${emAssignment.fullName}&name=${userInfo.name}&q4_email2=${userInfo.email} `,
			'_blank',
		);
	};

	useEffect(() => {
		dispatch(getEmAssignmentRequest());
	}, [dispatch]);

	return (
		<Container style={{ padding: '0px 20px 0 20px' }}>
			<EasTableWithoutFilter<TContractDocumentTableRow>
				tableStructure={tableStructure}
				items={contractDocuments as IPageResponse<TContractDocumentTableRow> | null}
				itemsIsLoading={
					contractDocumentsIsLoading || downloadedDocumentsIsLoading || contractDocumentIsLoading
				}
				handleAction={handleAction}
				skeletonRows={ROWS}
				highlightedRow={null}
				minWidth={740}
			>
				<Box
					sx={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
						p: '2px 4px',
					}}
				>
					<Typography sx={{ fontSize: '1.2rem', color: 'primary.main', fontWeight: 'bold' }}>
						Contract Documents
					</Typography>

					<Box
						sx={{
							display: 'flex',
							alignItems: 'center',
							gap: 1,
							flexDirection: 'row',
						}}
					>
						{(contractDocumentsIsLoading ||
							downloadedDocumentsIsLoading ||
							contractDocumentIsLoading) && <CircularProgress size={20} />}
						<Typography sx={{ fontSize: '1rem', color: 'primary.main', fontWeight: 'bold' }}>
							Merchant #{xMerchantId}
						</Typography>
					</Box>
					<Button
						variant="contained"
						color="primary"
						size="small"
						onClick={handleCancellationRequest}
						startIcon={<CancelIcon />}
					>
						Cancellation Request
					</Button>
				</Box>
			</EasTableWithoutFilter>
		</Container>
	);
};
